// The streaming diagnostic's tick (/app/v1/labs, ADR 0009); temporary.
import { z } from "zod";

export const LabsTick = z.object({ n: z.number().int(), of: z.number().int(), sentAt: z.string() });
export type LabsTick = z.infer<typeof LabsTick>;
